<template>
  <div class="app-bar-menu">
    <SurfaceNavBookmarkButton v-if="canIBookmarkWall" />
    <li v-if="canIRemake">
      <a role="button" target="_blank" :href="remakeUrl" class="app-bar-button app-bar-icon-text-button">
        <base-icon name="remake" />
        <span class="responsive-no-phone-only">{{ __('Remake') }}</span></a
      >
    </li>
    <li>
      <a role="button" target="_blank" :href="shareUrl" class="app-bar-button app-bar-icon-text-button">
        <base-icon name="share_arrow" />
        <span class="responsive-no-phone-only">{{ __('Share') }}</span>
      </a>
    </li>
    <li>
      <a
        role="button"
        target="_blank"
        :href="loginAndRedirectToWallUrl ? loginAndRedirectToWallUrl : showUrl"
        class="app-bar-button"
        :title="__('Open in new')"
        @click="reloadPage"
      >
        <base-icon name="open_in_new" />
      </a>
    </li>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapGetters } from 'vuex'
import SurfaceNavBookmarkButton from 'vuecomponents/SurfaceNavBookmarkButton'
import BaseIcon from 'vuecomponents/base_icon'
import { reload } from 'bits/location'

export default {
  components: { BaseIcon, SurfaceNavBookmarkButton },
  data: () => ({ isLoginAndRedirectToWallUrlExpired: false }),
  computed: {
    ...mapGetters(['links', 'canIRemake', 'canIBookmarkWall', 'loginAndRedirectToWallUrl']),
    showUrl() {
      return this.links.show
    },
    remakeUrl() {
      return this.showUrl + '#remake'
    },
    shareUrl() {
      return this.showUrl + '#share'
    },
  },
  mounted() {
    // Refer to DEEPLINK_RESPONSE_WINDOW_DURATION_WITH_BUFFER in app/services/lti_launch_context.rb
    const TIME_OUT = 15 * 60 * 1000
    setTimeout(() => (this.isLoginAndRedirectToWallUrlExpired = true), TIME_OUT)
  },
  methods: {
    reloadPage(e) {
      // Reload the embed wall to get a new loginAndRedirectToWallUrl when the loginAndRedirectToWallUrl is expired
      if (this.loginAndRedirectToWallUrl && this.isLoginAndRedirectToWallUrlExpired) {
        e.preventDefault()
        reload()
      }
    },
  },
}
</script>
